import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-letter-available',
  templateUrl: './request-letter-available.component.html',
  styleUrls: ['./request-letter-available.component.scss']
})
export class RequestLetterAvailableComponent implements OnInit {
@Input() request: any;
  constructor() { }

  ngOnInit() {
  }

}
